import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { AlertComponent } from './components/alert/alert.component';
import { AlertService } from './services/alert.service';
import { NavigationService } from './services/navigation.service';
import { MeService } from './services/me.service';
import {
  NgbModule,
  NgbActiveModal,
  NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CacheService } from './services/cache.service';
import { ObjectToArrayPipe } from './pipes/object-to-array.pipe';
import { RouterModule } from '@angular/router';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { BlockUIModule } from 'ng-block-ui';
import { SpinnerService } from './services/spinner.service';
import { TableComponent } from './components/table/table.component';
import { FormCacheService } from './services/form-cache.service';
import { InputComponent } from './components/input/input.component';
import { TextInputComponent } from './components/input/text-input/text-input.component';
import { SelectInputComponent } from './components/input/select-input/select-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchComponent } from './components/search/search.component';
import { CheckboxInputComponent } from './components/input/checkbox-input/checkbox-input.component';
import { CheckboxGroupComponent } from './components/checkbox-group/checkbox-group.component';
import { TextAreaComponent } from './components/input/text-area/text-area.component';
import { FormErrorComponent } from './components/form-error/form-error.component';
import { TrimWhitespaceDirective } from './directives/trim-whitespace.directive';
import { TrimLeadingAndTrailingWhitespaceDirective } from './directives/trim-leading-and-trailing-whitespace.directive';
import { PasswordStrengthComponent } from './components/password-strength/password-strength.component';
import { LocationService } from './services/location.service';
import { NoCutCopyPasteDirective } from './directives/no-cut-copy-paste.directive';
import { SwitchInputComponent } from './components/input/switch-input/switch-input.component';
import { NgxMaskModule } from 'ngx-mask';
import { DateInputComponent } from './components/input/date-input/date-input.component';
import { RadioInputComponent } from './components/input/radio-input/radio-input.component';
import { LoadingPipe } from './pipes/async-with-loading.pipe';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { EllipsisModule } from 'ngx-ellipsis';
import { RadioListInputComponent } from './components/input/radio-list-input/radio-list-input.component';
import { CheckboxListInputComponent } from './components/input/checkbox-list-input/checkbox-list-input.component';
import { SkipNavComponent } from './components/skip-nav/skip-nav.component';
import { RegexService } from './services/regex.service';
import { SortPipe } from './pipes/sort.pipe';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { CommonModule } from '@angular/common';
import { MatomoService } from './services/matomoService/matomo.service';
import { ObjectKeysPipe } from './pipes/object-keys.pipe';
import { LoaderComponent } from './components/loader/loader.component';
import { GovBannerComponent } from './components/gov-banner/gov-banner.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarItemComponent } from './components/sidebar/sidebar-item/sidebar-item.component';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    AlertComponent,
    ObjectToArrayPipe,
    ObjectKeysPipe,
    SpinnerComponent,
    TableComponent,
    InputComponent,
    TextInputComponent,
    SelectInputComponent,
    SearchComponent,
    CheckboxInputComponent,
    CheckboxGroupComponent,
    TextAreaComponent,
    FormErrorComponent,
    TrimWhitespaceDirective,
    TrimLeadingAndTrailingWhitespaceDirective,
    PasswordStrengthComponent,
    NoCutCopyPasteDirective,
    SwitchInputComponent,
    DateInputComponent,
    RadioInputComponent,
    LoadingPipe,
    AutoFocusDirective,
    RadioListInputComponent,
    CheckboxListInputComponent,
    SkipNavComponent,
    SortPipe,
    NotFoundComponent,
    LoaderComponent,
    GovBannerComponent,
    SidebarComponent,
    SidebarItemComponent,
  ],
  imports: [
    NgbModule,
    CommonModule,
    NgbNavModule,
    RouterModule,
    ReactiveFormsModule,
    BlockUIModule.forRoot(),
    NgxMaskModule.forRoot(),
    EllipsisModule,
    FormsModule,
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    InputComponent,
    SpinnerComponent,
    TableComponent,
    SearchComponent,
    CheckboxGroupComponent,
    FormErrorComponent,
    TrimWhitespaceDirective,
    TrimLeadingAndTrailingWhitespaceDirective,
    PasswordStrengthComponent,
    AlertComponent,
    LoadingPipe,
    ObjectKeysPipe,
    SkipNavComponent,
    LoaderComponent,
    GovBannerComponent,
    SidebarComponent,
    SidebarItemComponent,
  ],
  providers: [
    AlertService,
    NavigationService,
    MeService,
    NgbActiveModal,
    CacheService,
    SpinnerService,
    FormCacheService,
    LocationService,
    RegexService,
    MatomoService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HarpCommonModule {}
